export function accordion() {
  const els = document.querySelectorAll('.js-accordion');
  if(els.length){
    els.forEach((el, index) => {
      const trigger = el.querySelector('.js-trigger-accordion');
      if(trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          if(el.classList.contains('is-active')) {
            el.classList.remove('is-active')
          } else {
            el.classList.add('is-active')
          }
        });
      }
    });
  }
}